import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { Subscription } from 'rxjs/Subscription';

import { ApplicationStatus } from '../../enums/application-status.enum';
import { EnumHelper } from '../../helpers/enum-helper';
import { Application } from '../../models/application';
import { Meetup } from '../../models/meetup';
import { ApplicationService } from '../../services/application.service';
import { MeetupService } from '../../services/meetup.service';

@Component({
  selector: 'app-attendees',
  templateUrl: './attendees.component.html',
  styleUrls: ['./attendees.component.scss']
})
export class AttendeesComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

	public applications: Observable<Application[]>;
	public meetups: Observable<Meetup[]>;
	public selectedMeetup: string;
	public enumHelper: typeof EnumHelper = EnumHelper;
	public statuses: typeof ApplicationStatus = ApplicationStatus;
	public statusValues: number[] = Object.values(ApplicationStatus).filter( e => typeof( e ) == "number" );

  constructor(private applicationService: ApplicationService,
							private meetupService: MeetupService) {
		this.subscriptionManager = new Subscription();

		this.meetups = this.meetupService.getMeetups();
		this.subscriptionManager.add(this.meetupService.getNextMeetups().subscribe(next => {
			if (next.length > 0) {
				this.selectedMeetup = next[0].$key;
				this.getApplications(this.selectedMeetup);
			}
		}));
	}

  ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public getApplications(meetup: string): void {
		this.applications = this.applicationService.getApplicationsByMeetup(meetup);
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/attendees/attendees.component.ts